import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../shared/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { GETClickToEditComponent } from './click-to-edit/get-click-to-edit.component';
import { GETEditDataComponent } from './edit-data/edit-data.component';
import { PipeModule } from '../../../shared/pipes/pipe.module';
import { SharedModule } from '../../../shared/shared.module';

@NgModule({
  imports: [
      CommonModule,
      MaterialModule,
      FormsModule,
      ReactiveFormsModule,
    RouterModule,
    PipeModule,
    //SharedModule
    ],
  exports: [
    GETClickToEditComponent,
    GETEditDataComponent,
    //SharedModule
  ],
  declarations: [
    GETClickToEditComponent,
    GETEditDataComponent,
  ],
  providers: [

  ]
})
export class GETSharedModule { }
